export default __webpack_public_path__ + "static/media/devil.c8660c60.png";